<template>
    <div class="bg-white px-3 index" style="margin: 0 26px;margin-bottom: 0!important;">
        <div class="add_tits" ref="title">
            <el-form class="form-inlines" :inline="true">
                <el-form-item>
                    <el-button type="primary" size="small" @click="add">添加银行卡</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="ibox-content">
            <el-table :data="tableData" border v-loading="loading" :height="heights" ref="configurationTable">
                <el-table-column prop="bank" label="开户行名称" show-overflow-tooltip> </el-table-column>
                <el-table-column prop="grantee_name" label="所在地区" show-overflow-tooltip>
                    <template slot-scope="{row}">
                        <span>{{row.province_text}}/{{row.city_text}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="bank_outlets" label="银行网点" show-overflow-tooltip> </el-table-column>
                <el-table-column prop="name" label="开户人姓名" show-overflow-tooltip> </el-table-column>
                <el-table-column prop="phone" label="银行预留手机号" show-overflow-tooltip> </el-table-column>
                <el-table-column prop="bank_card" label="银行卡号" show-overflow-tooltip> </el-table-column>
                <el-table-column prop="pay_price" label="操作" width="150" fixed="right">
                    <template slot-scope="{row}">
                        <el-button type="primary" size="small" @click="edit(row)">编辑</el-button>
                        <el-button size="small" @click="del(row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- <div class="u-f u-ac u-jsb ft_mr">
                <div></div>
                <div>
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="currentPage" :page-sizes="[15, 30, 50, 100]" :page-size="pagesize"
                        layout="total, sizes, prev, pager, next, jumper" :total="count">
                    </el-pagination>
                </div>
            </div> -->
        </div>
        <!-- 添加/编辑 -->
        <el-dialog :title="eid?'编辑':'添加'" :visible.sync="addModal" center width="30%" :close-on-click-modal='false'>
            <el-form :model="formData" ref="formData" label-width="140px" :rules="rules">
                <el-form-item label="开户行名称：" prop="bank">
                    <el-select v-model="formData.bank" placeholder="请选择开户行" size="small" filterable
                        @change="selectbank">
                        <el-option v-for="item in bank_options" :key="item.id" :label="item.content_name"
                            :value="item.content_name">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="所在地区：" required>
                    <div class=" u-f">
                        <el-form-item prop="province_code" style="margin-right:10px;margin-bottom:0 !important;">
                            <el-select style="width:112px" v-model="formData.province_code" placeholder="请选择"
                                size="small" @change="getsq">
                                <el-option v-for="item in sf_options" :key="item.code" :label="item.name"
                                    :value="item.code">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item prop="city_code" style="margin-right:10px;margin-bottom:0 !important;">
                            <el-select style="width:112px" v-model="formData.city_code" placeholder="请选择" size="small"
                                clearable>
                                <el-option v-for="item in sq_options" :key="item.code" :label="item.name"
                                    :value="item.code">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </el-form-item>
                <el-form-item label="银行网点：" prop="bank_outlets">
                    <el-input v-model="formData.bank_outlets" size="small" style="min-width:100px;max-width:300px"
                        placeholder="请输入银行网点">
                    </el-input>
                </el-form-item>
                <el-form-item label="开户人姓名：" prop="name">
                    <el-input v-model="formData.name" size="small" style="min-width:100px;max-width:300px"
                        placeholder="请输入开户人姓名">
                    </el-input>
                </el-form-item>
                <el-form-item label="银行卡号：" prop="bank_card">
                    <el-input v-model="formData.bank_card" size="small" style="min-width:100px;max-width:300px"
                        placeholder="请输入银行卡号">
                    </el-input>
                </el-form-item>
                <el-form-item label="银行预留手机号：" required>
                    <div class="u-f">
                        <el-form-item label="" prop="phone">
                            <el-input v-model="formData.phone" :disabled='!is_edit_phone' size="small"
                                style="min-width:100px;max-width:300px" placeholder="请输入银行预留手机号">
                            </el-input>
                        </el-form-item>
                        <div class="p_edit_s" v-if="iseditinfo">
                            <el-button type="text" @click="swipeisedit">{{is_edit_phone?'取消':'修改'}}</el-button>
                        </div>
                    </div>
                    <div class="u-f" v-if="is_edit_phone">
                        <el-input v-model="formData.code" size="small" style="width:100px" placeholder="验证码">
                        </el-input>
                        <div class="p_edit_s">
                            <el-button v-if="smsBtnShow" type="text" @click="getcode">获取验证码</el-button>
                            <el-button v-if="!smsBtnShow" type="text"><em>{{codeSecond}}</em>秒后重发</el-button>
                        </div>
                    </div>
                </el-form-item>

            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="addModal = false">取 消</el-button>
                <el-button size="small" type="primary" :loading='submitloading' @click="submit('formData')">确 定
                </el-button>
            </span>
        </el-dialog>
    </div>
</template>


<script>
    import {
        mapState
    } from 'vuex'
    export default {
        data() {
            return {
                formData: {
                    time: '',
                    docname: '',
                    lx_value: '',
                    doc_options: [],
                    lx_options: [{
                            id: 1,
                            name: '付费咨询'
                        },
                        {
                            id: 2,
                            name: '头条打赏'
                        },
                        {
                            id: 3,
                            name: '发布文章奖金'
                        },
                        {
                            id: 4,
                            name: '用户报道奖金'
                        },
                        {
                            id: 5,
                            name: '活动奖金'
                        },
                    ],
                },
                formData: {
                    bank: '',
                    bank_value: '',
                    province_code: '',
                    city_code: '',
                    bank_card: '',
                    phone: '',
                    name: '',
                    bank_outlets: '',
                    code: '',
                },
                rules: {
                    bank: [{
                        required: true,
                        message: '请选择开户行',
                        trigger: 'blur'
                    }],
                    province_code: [{
                        required: true,
                        message: '请选择省份',
                        trigger: 'blur'
                    }],
                    city_code: [{
                        required: true,
                        message: '请选择市',
                        trigger: 'blur'
                    }],
                    bank_card: [{
                        required: true,
                        message: '请输入卡号',
                        trigger: 'blur'
                    }],
                    phone: [{
                        required: true,
                        message: '请输入预留手机号',
                        trigger: 'blur'
                    }],
                    name: [{
                        required: true,
                        message: '请输入开户人姓名',
                        trigger: 'blur'
                    }],
                    bank_outlets: [{
                        required: true,
                        message: '请输入银行网点',
                        trigger: 'blur'
                    }],
                },
                loading: false,
                tableData: [],
                currentPage: 1,
                pagesize: 15,
                count: 0,
                heights: null,
                dialogVisible: false,
                date: xaoi.date,
                exportModal: false,
                exportForm: {
                    time: []
                },
                submitloading: false,

                eid: '',
                addModal: false,
                bank_options: [],
                sf_options: [],
                sq_options: [],
                is_edit_phone: false,
                codeSecond: 60,
                smsBtnShow: true,
                iseditinfo: false,
                editData: '',
                Codeinterval: null
            };
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            })
        },
        mounted() {
            let that = this
            that.begin()
            that.getHeight()
            this.getbank()
            this.getsf()
        },
        methods: {
            // 获取高度
            getHeight() {
                let that = this;
                var title = that.$refs.title.offsetHeight
                that.heights = window.innerHeight - title - 180 + 'px'
                window.onresize = () => {
                    var title = that.$refs.title.offsetHeight
                    that.heights = window.innerHeight - title - 200 + 'px'
                }
            },
            add() {
                this.clear_form()
                this.addModal = true
                this.iseditinfo = false
                this.is_edit_phone = true
            },
            begin() {
                let that = this
                that.currentPage = 1
                that.pagesize = 15
                that.search()
            },
            search() {
                let that = this
                that.loading = true
                axios
                    .post("/admin/pc/bank/myBankCard", {}, {
                        token: true
                    })
                    .then(response => {
                        that.loading = false
                        that.tableData = response.data.data
                    })
                    .catch(error => {})
            },
            handleSizeChange(val) {
                let that = this
                that.pagesize = val;
                that.search()
            },
            handleCurrentChange(val) {
                let that = this
                that.currentPage = val;
                that.search()
            },
            //本月
            getDate6() {
                let that = this
                var date = new Date();
                date.setDate(1);
                var month = parseInt(date.getMonth() + 1);
                var day = date.getDate();
                month = month < 10 ? "0" + month : month;
                day = day < 10 ? "0" + day : day;
                var start = date.getFullYear() + "-" + month + "-" + day;
                var date = new Date();
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                month = month < 10 ? "0" + month : month;
                var day = new Date(year, month, 0);
                var end = year + "-" + month + "-" + day.getDate();
                this.formData.time = [start, end]
                that.begin()
            },
            selectbank(v) {
                this.bank_options.forEach(e => {
                    if (e.content_name == v) {
                        this.formData.bank_value = e.content_value
                    }
                })
            },
            submit(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if (this.is_edit_phone && this.formData.code == '') return this.$message.error(
                            '请输入验证码')
                        let url = this.eid ? '/admin/pc/bank/update' : '/admin/pc/bank/save'
                        this.submitloading = true
                        let params = {
                            id: this.eid,
                            bank: this.formData.bank,
                            bank_card: this.formData.bank_card,
                            bank_code: this.formData.bank_value,
                            bank_outlets: this.formData.bank_outlets,
                            city: this.formData.city_code,
                            name: this.formData.name,
                            province: this.formData.province_code,
                            phone: this.formData.phone,
                            code: this.is_edit_phone ? this.formData.code : '111',
                        }
                        this.axios.post(url, params, {
                            token: true
                        }).then(res => {
                            this.submitloading = false
                            if (res.data.code == 200) {
                                this.$message.success('操作成功！')
                                this.addModal = false
                                clearInterval(this.Codeinterval);
                                this.Codeinterval = null
                                this.codeSecond = 0;
                                this.smsBtnShow = true;
                                this.search()
                            } else {
                                this.$message.error(res.data.msg)
                            }
                        }).catch(err => {
                            this.submitloading = false
                            this.$message.error('异常！')

                        })

                    } else {
                        return false;
                    }
                });
            },
            clear_form() {
                this.formData = {
                    bank: '',
                    province_code: '',
                    city_code: '',
                    bank_card: '',
                    phone: '',
                    name: '',
                    bank_outlets: '',
                    code: ''
                }
            },

            getbank() {
                this.axios.post('/admin/MgetContentBySysTypeId', {
                    sys_id: 1,
                    type_id: 20
                }, {
                    token: true
                }).then(res => {
                    this.bank_options = res.data.data
                })
            },
            // 获取省份
            getsf() {
                let that = this
                axios
                    .post("/admin/h5/Area/getProvince_vue", {}, {
                        token: true
                    })
                    .then(response => {
                        that.sf_options = response.data.data
                    })
                    .catch(error => {})
            },
            getsq() {
                let that = this
                that.sq_options = []
                that.formData.city_code = ''
                axios
                    .post("/admin/h5/Area/getChild_vue", {
                        parentcode: that.formData.province_code,
                    }, {
                        token: true
                    })
                    .then(response => {
                        that.sq_options = response.data.data
                    })
                    .catch(error => {})
            },
            edit(r) {
                this.eid = r.id
                this.editData = r
                this.formData = {
                    bank: r.bank,
                    bank_value: r.bank_code,
                    bank_card: r.bank_card,
                    phone: r.phone,
                    name: r.name,
                    bank_outlets: r.bank_outlets,
                    code: ''
                }
                this.formData.province_code = r.province + ''
                this.getsq()
                this.formData.city_code = r.city + ''
                this.addModal = true
                this.iseditinfo = true
                this.is_edit_phone = false
            },
            del(r) {
                this.$confirm('确认删除此银行卡信息吗？, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.axios.post('/admin/pc/bank/del', {
                        id: r.id
                    }, {
                        token: true
                    }).then(res => {
                        if (res.data.code == 200) {
                            this.$message.success('删除成功！')
                            this.search()
                        } else {
                            this.$message.error(res.data.msg)
                        }
                    })
                }).catch(() => {

                });
            },
            swipeisedit() {
                this.is_edit_phone = !this.is_edit_phone
                if (!this.is_edit_phone) {
                    this.formData.phone = this.editData.phone
                }
            },
            getcode() {
                if (!/^1[3-9]\d{9}$/.test(this.formData.phone)) return this.$message('手机号格式不正确')
                this.axios.post('/admin/pc/sendMsg/code', {
                    phone: this.formData.phone
                }, {
                    token: true
                }).then(res => {
                    if (res.data.code == 200) {
                        this.$message.success('验证码发送成功，请注意接收！')
                        this.djs()
                    } else {
                        this.$message.error(res.data.msg)
                    }
                })
            },
            djs() {
                this.smsBtnShow = false;
                this.codeSecond = 60;
                this.Codeinterval = setInterval(() => {
                    this.codeSecond--;
                    if (this.codeSecond < 1) {
                        clearInterval(this.Codeinterval);
                        this.Codeinterval = null
                        this.codeSecond = 0;
                        this.smsBtnShow = true;
                    }
                }, 1000);
            },



        },

    };
</script>


<style lang="scss" scoped>
    .index {
        border-radius: 6px;
        overflow: hidden;
        padding-bottom: 15px;

        .p_edit_s {
            margin-left: 5px;

            em {
                padding: 0 5px;
            }
        }

        /deep/.dialog-footer {
            .el-button--primary {
                background-color: #23bcca;
                border-color: #23bcca;
            }
        }

    }
</style>